import { render, staticRenderFns } from "./waterControl.vue?vue&type=template&id=8b22023c&"
import script from "./waterControl.vue?vue&type=script&lang=js&"
export * from "./waterControl.vue?vue&type=script&lang=js&"
import style0 from "./waterControl.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports